import React from 'react';
import type { FC } from 'react';
import { Box, ConfirmInput } from '@wix/cli-ui-kit';
import { useTranslation } from '@wix/cli-i18n';
import { useWixCliAppBi } from '../../../bi/index.js';

interface ConfirmMinorVersionProps {
  onConfirmed: () => void;
}

export const ConfirmMinorVersion: FC<ConfirmMinorVersionProps> = (props) => {
  const { onConfirmed } = props;

  const bi = useWixCliAppBi();
  const { t } = useTranslation();

  return (
    <Box flexDirection="column" paddingBottom={1}>
      <ConfirmInput
        label={t('release_command.confirm_version_creation')}
        initialValue={true}
        onSubmit={(confirm) => {
          bi.cliFlowStepAnswered({
            question: t('release_command.confirm_version_creation'),
            questionKey: 'release_command.confirm_version_creation',
            answer: String(confirm),
          });

          if (confirm) {
            onConfirmed();
          }
        }}
      />
    </Box>
  );
};
